export const getAllUrls = (state) => state.pageTemplates.allUrls;

export const getCurrentPageDataByUrl = (state, url) => {
  const allIds = state.pageTemplates.allIds;

  const id = allIds.find((id) => {
    const item = state.pageTemplates.byId[id];
    return item.friendly_url === url;
  });

  if (id) {
    return state.pageTemplates.byId[id];
  }

  return false;
};
